import React, { FC } from "react";

import RefValue from "../../Form/RefInput/RefValue/RefValue";

type AddressFormatProps = {
    address: MyBrokerApi.Address;
};

const AddressFormat: FC<AddressFormatProps> = ({ address }) => {
    const formatSubAddress = (subAddress: string[]) => subAddress.filter((detail) => !!detail).join(" ");
    return (
        <>
            {[
                formatSubAddress([address?.street, address?.houseNumber, address?.boxNumber]),
                formatSubAddress([address?.zipCode, address?.city]),
                address?.country?.id ? (
                    <RefValue table="country" value={address?.country?.id} onEmpty="" onLoading="" />
                ) : (
                    ""
                ),
            ]
                .filter((detail) => !!detail)
                .reduce(
                    (prev, curr) =>
                        prev === "" ? (
                            <>{curr}</>
                        ) : (
                            <>
                                {prev}, {curr}
                            </>
                        ),
                    "",
                )}
        </>
    );
};

export default AddressFormat;
